import React, { useState } from "react";
import WeatherInfo from "./weatherInfo";
import WeatherForecast from "./weatherForecast";
import "./weathers.css";
import axios from "axios";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      city: response.data.city,
      country: response.data.country,
      date: new Date(response.data.time * 1000),
      description: response.data.condition.description,
      icon: response.data.condition.icon,
      temperature: Math.round(response.data.temperature.current),
      feelsLike: Math.round(response.data.temperature.feels_like),
      wind: Math.round(response.data.wind.speed),
      humidity: Math.round(response.data.temperature.humidity),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleInputChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "260420cae416f4dteddo330fbd8c9c7b";
    const units = "metric";
    const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=${units}`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="weatherContainer">
        <form onSubmit={handleSubmit} className="searchForm">
          <div className="row">
            <div className="col-10">
              <input
                type="search"
                autoFocus={true}
                placeholder="Whats the weather like in..."
                className="searchInput"
                onChange={handleInputChange}
              />
            </div>
            <div className="col-1">
              <input type="submit" value="🔎" />
            </div>
            <div className="col-1">
              <input type="submit" value="📍" />
            </div>
          </div>
        </form>

        <hr></hr>
        <WeatherInfo data={weatherData} />
        <hr></hr>
        <div className="row">
          <WeatherForecast cities={weatherData.city} />
        </div>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
